<h5 *ngIf="nextGame$ | async">Next Game</h5>
<fgb-game-card [game]="nextGame$ | async"></fgb-game-card>
